module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Brush-c778f8873e4747bddb7bd45ce32b2413.svg";